import React from 'react'

import { string } from 'prop-types'

import CreditsArea from 'Pods/Shared/ItemPageComponents/CreditsArea/CreditsArea'

function CreditsAreaContent({ designerName, itemTitle }) {
  const copyText = (
    <>
      Love this model? Help others discover more of{' '}
      {designerName}'s amazing work by sharing a link to it.{' '}
      Post this link anywhere online - in a social media post, blog, forum or website:
    </>
  )

  const buttonText = `${itemTitle} on CGTrader`

  return (
    <CreditsArea
      copyText={copyText}
      buttonText={buttonText}
      copyUrl={window.location.pathname}
      designerName={designerName}
    />
  )
}

CreditsAreaContent.propTypes = {
  designerName: string.isRequired,
  itemTitle: string.isRequired,
}

export default CreditsAreaContent
